import { render } from "./FormTextarea.vue?vue&type=template&id=6f19089b"
import script from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTextarea.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/FormTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f19089b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f19089b', __exports__)) {
    api.reload('6f19089b', __exports__)
  }
  
  module.hot.accept("./FormTextarea.vue?vue&type=template&id=6f19089b", () => {
    api.rerender('6f19089b', render)
  })

}


export default __exports__